<template>
	<el-dialog title="修改资料" :visible.sync="infoModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">

		<!-- 表单内容 -->
		<el-form :rules="info_rules" ref="form_info" :model="form_info" label-width="100px">
			<el-form-item label="头像">
				<!-- 图片选择 -->
				<!-- <span v-if="!form_info.headUrl" class="btn btn-light border" style="padding: 25px 30px;" @click="chooseImage">
					<i class="el-icon-plus" style="font-size: 30px;"></i>
				</span>
				<img v-else @click="chooseImage" :src="form_info.headUrl" alt="" class="rounded" style="width: 90px;height: auto; cursor: pointer;"> -->
				
				<el-upload
				  name="file"
				    class="avatar-uploader"
				    action="/admin/image/uploadNew"
				    :headers="{token:$store.state.user.token}"
				    :data="{type:'InsHead'}"
				  :show-file-list="false"
				  :on-success="handleAvatarSuccess"
				  :before-upload="beforeAvatarUpload">
				  <img v-if="form_info.headUrl" :src="form_info.headUrl" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				
			</el-form-item>
			<el-form-item label="名称" prop="name">
				<el-input v-model="form_info.name" placeholder="管理员名称" clearable size="small" style="width: 80%;"></el-input>
			</el-form-item>
		
			<!-- <el-form-item label="排序">
		<el-input-number size="small" v-model="form.order" :min="0"></el-input-number>
	</el-form-item> -->
			
	
		</el-form>
	
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">取 消</el-button>
			<el-button type="primary" @click="submitinfo">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { commondecrypt } from '@/main';
	const user = JSON.parse(window.sessionStorage.getItem('user'))
	export default {
		inject: ['app'],
		props: {
			infoModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				form_info:{
					headUrl:user.head?user.head:'',
					headId:0,
					name:user.name
				},
				info_rules: {
					name: [{
						required: true,
						message: "名称不能为空",
						trigger: 'blur',
					}, ],
				
		
				},
			}
		},
		methods:{
			handleAvatarSuccess(res, file) {
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form_info.headUrl = res.encryption.data.list.url
				}
			 },
		  beforeAvatarUpload(file) {
			
		  },
			hide(){
				this.$emit('hide')
			},
			// 选择图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form_info, 'headUrl', res[0].url);
					this.form_info['headId'] = res[0].id
					this.$set(this.form_info, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			//提交
			submitinfo() {
				this.$refs.form_info.validate(res => {
					if (res) {
						
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.axios.post('/admin/user/editInfo', this.form_info, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						user.name = this.form_info.name
						user.head = this.form_info.headUrl
						window.sessionStorage.setItem('user',JSON.stringify(user))
						this.$message({
							message:   '修改成功',
							type: 'success'
						});
						this.hide()
					}
				}).catch(err => {
					
				})
			}
			
		}
	}
</script>

<style>
</style>
